const getters = {
  isLrLoading: state => state.isLrLoading,
  lrList: state => state.list,
  isUploading: state => state.isUploading,
  certifications: state => state.certifications,
  isLoading: state => state.isLoading,
  centralHo: state => state.centralHo,
  rolePermissions: state => state.rolePermissions,
  permissionList: state => state.permissionList,
};

export default getters;
